export default "__VITE_ASSET__C_usP0YY__"